var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.1818V3H5.75414V7.31037H10.2411V3H12V13.1818H10.2411V8.85653H5.75414V13.1818H4Z",
    fill: "#2D3958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalal);
export default __webpack_public_path__ + "static/media/halal.f0389ec0e0db72c0a4c477340020f52c.svg";
export { ForwardRef as ReactComponent };